window.onload = function () {


};

// ページの読み込みと解析が完了した後に有効になる処理を記述
window.addEventListener('DOMContentLoaded', function (e) {

    // 検索ボタンを押したときの処理
    $(document).on('click', '#execute_search', function () {
        // 遷移先URL
        let to_url;
        to_url = window.location.protocol + '//' + window.location.host;
        // パラメータ付与用の一時変数
        let url;

        let p_index = window.location.pathname.indexOf('/p/');
        let telegram_path = window.location.pathname.substring(0,p_index);

        to_url += telegram_path;

        const category = $('#select_category').val();
        const price = $('#select_price').val();
        const priceFrom = $('#price_from').val();
        const priceTo = $('#price_to').val();

        const from = parseInt($('#price_from').val());
        const to = parseInt($('#price_to').val());

        // 両方入力されている場合のみ大小比較
        if (from && to && from > to) {
            alert('最小価格（FROM）には最大価格（TO）より小さい値を入力してください。');
            return false; // 処理を中断
        }

        if (category || price || priceFrom || priceTo) {
            if (category) {
                to_url += '/i/' + category + '/';
                url = new URL(to_url);
                if (price) url.searchParams.set('price', price);
                if (priceFrom) url.searchParams.set('price_from', priceFrom);
                if (priceTo) url.searchParams.set('price_to', priceTo);
            }else if (price || priceFrom || priceTo) {
                to_url += '/p/' + price + '/';
                url = new URL(to_url);
                if (priceFrom) url.searchParams.set('price_from', priceFrom);
                if (priceTo) url.searchParams.set('price_to', priceTo);
            }
        }
        console.log('goto ' + to_url);
        // 最終的なURLを取得して遷移
        to_url = url.toString();
        window.location.href = to_url;
    });
});
